import React from 'react';
import styled from 'styled-components';

const PlansSection: React.FC = () => {
  return (
    <Container id="plans">
      <MainWrapper>
        <Header>
          Ready to Start <span style={{ color: '#784dcc' }}>Trading ?</span>
        </Header>
        <Description>
          Choose from our carefully crafted plans designed to suit traders of all levels. 
          Whether you're just starting out or looking to scale your trading, we have the perfect plan for you. 
          Get access to premium tools, real-time signals, and expert support to take your trading to the next level.
        </Description>
        <ButtonWrapper>
          <button   
            onClick={() => window.location.href = "https://whop.com/tradesimple/"}
            className="button-prim"
          >
            <div style={{
              display: "flex",
              fontSize: 16,
              justifyContent: "center",
              alignItems: "center",
              margin: 0,
              padding: 0,
            }}>
              Explore Plans
            </div>
          </button>
        </ButtonWrapper>
      </MainWrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 00px 20px 60px 20px;
  background: #E7ECF9;
  margin: 0;
`;

const MainWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
  background: #fff;
  border-radius: 15px;
  padding: 50px 40px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    padding: 35px 25px;
  }
`;

const Header = styled.h1`
  text-align: center;
  color: #000;
  font-weight: 500;
  font-size: 45px;
  font-family: var(--font-bold);
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const Description = styled.p`
  text-align: center;
  font-size: 17px;
  color: #666666;
  line-height: 1.8;
  margin: 0 auto 35px;
  max-width: 900px;
  
  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 25px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default PlansSection;

